// RegenerateStageResponse schema — workflow response for POST /ingest/regenerate-stage.
//
// Session 39: extracted from packages/web/src/api/ingest.ts (TS-only interface)
// into a shared Zod schema. Returned when Cloudflare Workflow binding is available.
// Mirrors the shape of v4 AsyncJobResponseSchema but specific to the legacy
// regenerate-stage endpoint (not the v4 /ingest/regenerate endpoint).
import { z } from 'zod';
export const RegenerateStageResponseSchema = z.object({
    runId: z.string(),
    instanceId: z.string(),
    statusUrl: z.string(),
}).passthrough();
//# sourceMappingURL=regen-stage-response.js.map